import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { EumEditor } from '@appbase/components/editor'
import { mapGetters } from 'vuex'
import * as accountTypes from '@account/store/types'

@Component({
  components: {
    EumEditor
  },
  computed: mapGetters({
    userCurrent: accountTypes.CURRENT,
  }),
})
export default class WriteBody extends Vue {
  @Prop({ type: String, default: '' }) value!: string
  @Prop({ type: Boolean, default: false }) readonly!: boolean

  userCurrent!: account.TCurrent

  tinyopts: eumEditor.EditorOptions = {
    menubar: false,
    inline: false,
    height: '100%',
    // setup: function(e: any) {
    //   (window as any).currentEditor = e;
    // }
  }
  dext5opts: editor.dext5.DEXT5Config = {
    EditorBorder: '0',
    Lang: 'ko_KR',
  }

  created() {
    this.dext5opts.Lang = this.userCurrent.userConfig.language
  }
}
